import React, { PropsWithChildren, useEffect } from "react";
import { getUserGroup, useAuth } from "shared-auth";
import { HeapService, initBraze, InitializeBrazeProps } from "shared-services";
import { MemberGroups } from "shared-types";
import { config } from "../../../../config";

const heap = new HeapService(config.oidc?.authority);

const AnalyticsProvider = ({ children }: PropsWithChildren) => {
  const { isAuthenticated, user } = useAuth();

  useEffect(() => {
    if (isAuthenticated && user) {
      const brazeProps: InitializeBrazeProps = {
        memberGroupFromToken: getUserGroup() || MemberGroups.anonymous,
        portalId: user.profile.sub,
        brazeConfig: {
          apiKey: config?.braze.apiKey,
          baseUrl: config?.braze.baseUrl,
        },
      };

      if (config?.braze.apiKey) initBraze(brazeProps);

      heap.setUserDetails();
    }
  }, [isAuthenticated, user]);

  return <>{children}</>;
};

export default AnalyticsProvider;
